import {
    type TranslationKey,
    type ResourcesSource,
    I18nService
} from "@bb-libs/services/i18n";
import type {
    Locale,
    CurrencyCode,
    TimeZoneOffset,
    OddsType
} from '@bb-libs/types';

window.Localization = (function () {
    let i18nService: I18nService;

    /*
     * метод 'window.Localization.init' вызывается ТОЛЬКО в .cshtml файлах
     * везде в него передается значение '@culture'
     * этот вызов НИКОГДА не участвует в проверке типов
     * типизация culture оставлена намеренно, чтобы подчеркнуть, что вызов идет "на бэке"
     * и туда может упасть что угодно
     * 
     * пока что типа Locale это тоже строка
     * если он все-таки станет юнионом, это место будет местом конфликта и тут будет писаться адптер
     */
    function init(
        version: string,
        culture: string
    ) {
        $.ajax(`/resources/getresources/${version}/${culture}`, {
            data: {},
            success: (response: ResourcesSource) => {
                const locale = culture satisfies Locale;
                const currency: CurrencyCode = window?.globalAppSettings?.currentUser?.defaultBalance?.currencyCode as CurrencyCode ?? 'RUB';
                const timeZoneOffset: TimeZoneOffset = window?.globalAppSettings?.timeOffset ?? 0;
                const oddsType: OddsType = window?.globalAppSettings?.oddsType as OddsType ?? 'European';

                i18nService = new I18nService(
                    locale,
                    response,
                    {
                        timeZoneOffset
                    },
                    {
                        currency,
                        oddsType,
                        hideCurrencySymbol: window?.globalAppSettings?.hideCurrency ?? false,
                    },
                    {
                        disableFallbacks: true
                    }
                );

                window.i18n = i18nService;
            },
            async: false
        });
    }

    function getLanguage() {
        return (<any>window).globalAppSettings.lang; //TODO: get from cookie
    }

    function changeLanguage(lang: string) {
        const currentPath = window.location.pathname;
        const currentLang = getLanguage();

        if (currentPath === `/${currentLang}` || currentPath.startsWith(`/${currentLang}/`)) {
            window.location.href = `/${lang}` + currentPath.substring(3) + window.location.search;
        }
    }

    function getString(key: TranslationKey, defaultValue: string) : string {
        return i18nService?.translate(key, defaultValue) || defaultValue;
    }

    return {
        init,
        getString,
        getLanguage,
        changeLanguage,
    }
})();
